import { SvgIcon, SvgIconProps } from "@mui/material";

const AdminIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <g>
            <path d="M18.2222 4.8H14.5067C14.1333 3.756 13.1556 3 12 3C10.8444 3 9.86667 3.756 9.49333 4.8H5.77778C4.8 4.8 4 5.61 4 6.6V19.2C4 20.19 4.8 21 5.77778 21H18.2222C19.2 21 20 20.19 20 19.2V6.6C20 5.61 19.2 4.8 18.2222 4.8ZM12 4.8C12.4889 4.8 12.8889 5.205 12.8889 5.7C12.8889 6.195 12.4889 6.6 12 6.6C11.5111 6.6 11.1111 6.195 11.1111 5.7C11.1111 5.205 11.5111 4.8 12 4.8ZM12 8.4C13.4756 8.4 14.6667 9.606 14.6667 11.1C14.6667 12.594 13.4756 13.8 12 13.8C10.5244 13.8 9.33333 12.594 9.33333 11.1C9.33333 9.606 10.5244 8.4 12 8.4ZM17.3333 19.2H6.66667V17.94C6.66667 16.14 10.2222 15.15 12 15.15C13.7778 15.15 17.3333 16.14 17.3333 17.94V19.2Z" fill="currentColor" />
        </g>
    </SvgIcon>
);

export default AdminIcon;
